<template>
  <div class="gearlist">
    <CdrLink
      class="gearlist__trigger"
      data-ui="gearlist-trigger"
      aria-haspopup="dialog"
      tag="button"
      @click="handleClick"
    >
      Gear list
    </CdrLink>
    <CdrModal
      :opened="isModalOpen"
      label="Gear list"
      aria-described-by="gear-description"
      @closed="closeModal"
    >
      <template #title>
        <CdrText
          tag="h3"
          class="gearlist__title"
        >
          Gear list
        </CdrText>
      </template>
      <div data-ui="gearlist-modal-content">
        <template v-if="showBringToClassItems">
          <span
            id="gear-description"
            class="gearlist__description"
          >
            A list of required and optional gear items to bring to class, as well as gear provided
            by REI.
          </span>
          <h3 class="gearlist__bring-to">Bring to class:</h3>
          <template v-if="required">
            <p class="gearlist__subheading">
              {{ required.title }}
            </p>
            <SessionGearlistListComponent
              :items="required.items"
              :type="required.type"
            />
          </template>
          <template v-if="optional">
            <p class="gearlist__subheading">
              {{ optional.title }}
            </p>
            <SessionGearlistListComponent
              :items="optional.items"
              :type="optional.type"
            />
          </template>
        </template>
        <template v-if="provided">
          <h3 class="gearlist__provided-title">
            {{ provided.title }}
          </h3>
          <SessionGearlistListComponent
            :items="provided.items"
            :type="provided.type"
          />
        </template>
      </div>
    </CdrModal>
  </div>
</template>

<script>
import { CdrLink, CdrModal, CdrText } from '@rei/cedar';
import SessionGearlistListComponent from './SessionGearlistListComponent.vue';
import metrics from '../mixins/metrics';

export default {
  name: 'SessionGearlistComponent',
  components: {
    CdrLink,
    CdrModal,
    CdrText,
    SessionGearlistListComponent,
  },
  mixins: [metrics],
  props: {
    required: {
      type: [Boolean, Object],
      required: true,
    },
    optional: {
      type: [Boolean, Object],
      required: true,
    },
    provided: {
      type: [Boolean, Object],
      required: true,
    },
  },
  data: () => ({ isModalOpen: false }),
  computed: {
    showBringToClassItems() {
      // filters any valse value
      return [this.required, this.optional].filter((element) => !!element).length > 0;
    },
  },
  methods: {
    handleClick() {
      this.metricsClick({ linkName: '{{ pageName }}_gearlist modal_open' });
      this.isModalOpen = !this.isModalOpen;
    },
    closeModal() {
      this.metricsClick({ linkName: '{{ pageName }}_gearlist modal_close' });
      this.isModalOpen = false;
    },
  },
};
</script>
